export enum TOAST_TYPE {
  ERROR,
  WARN,
  INFO,
  SUCCESS,
}
